import { useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { setActiveZone } from './zoneThunks'
import { ZoneTypeEnum } from '../../shared/types'
import { fetchActiveDossier } from '../../features/dossier/dossierThunks'
import { selectAllUserData } from '../../selectors/userSelectors'
import { clearZoneError } from './zoneSlice'
import { getMockUserCoordsStorage } from '../../shared/utils/loadMockUserCoords.utils'

const useZoneContainer = () => {
  const debug = process.env.REACT_APP_DEBUG === 'true' ? true : false
  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  const dispatch = useAppDispatch()

  const [counter, setCounter] = useState(0)

  useEffect(() => {
    dispatch(clearZoneError())
  }, [dispatch])

  // =======================
  // Selectors
  // =======================
  const {
    data: poiData,
    loading: poiLoading,
    error: poiError,
  } = useAppSelector((state) => state.poi.nearby) ?? []

  // check for mock coords
  const { overridden: userLocationOverridden } = useAppSelector(
    (state) => state.userLocation
  )
  const mockLSCoords = getMockUserCoordsStorage()

  // TESTING ALT METHODS:

  // 1
  // const {
  //   profile,
  //   loading: profileLoading,
  //   error: profileError,
  // } = useAppSelector((state) => state.user)
  // const {
  //   data: zoneData,
  //   loading: zoneLoading,
  //   error: zoneError,
  // } = useAppSelector((state) => state.zone)
  // const {
  //   data: dossierData,
  //   loading: dossierLoading,
  //   error: dossierError,
  // } = useAppSelector((state) => state?.dossier)
  const rawDossier = useAppSelector((state) => state?.dossier)
  debugP2 && console.log('\n*****\nDossier bug: rawDossier:', rawDossier)

  // 2
  const allUserData = useAppSelector(selectAllUserData) || {}

  const {
    userProfile: profile,
    userCoords,
    zone: zoneData,
    dossier: dossierData,
    loading: loadingUserData,
    error: errorUserData,
  } = allUserData
  debugP2 &&
    console.log(
      'Dossier bug: selectAllUserData:',
      dossierData,
      '\nuserProfile',
      profile,
      '\nerror:',
      errorUserData,
      '\n*****\n'
    )

  // =======================
  // Effects
  // =======================
  useEffect(() => {
    if (!zoneData && profile?.activeZoneId) {
      const body = {
        zoneId: profile.activeZoneId,
        lat: userCoords?.lat,
        long: userCoords?.long,
      }
      dispatch(setActiveZone(body))
    } else if (
      zoneData?.id &&
      !dossierData &&
      !loadingUserData?.dossier &&
      !loadingUserData?.zone &&
      counter < 10
    ) {
      // fetch dossier if active zone exists, and dossier not loaded in state
      setCounter(counter + 1)
      console.log(
        'Not fetching zone data again. already exists. might want to combine in state. counter = ',
        counter
      )
      console.log('❗useZone')
      dispatch(fetchActiveDossier())
    }
  }, [profile, zoneData, counter, loadingUserData, errorUserData])

  // handle the error message
  let error = null
  const userError =
    errorUserData?.user ||
    errorUserData?.zone ||
    errorUserData?.dossier ||
    errorUserData?.detectedZone
      ? errorUserData
      : null

  // if (usingMockCoords) {
  //   // ignore the radar error if using mock coords
  //   error = null
  // } else
  if (userError) {
    error = userError
  } else if (poiError) {
    error = `Radar: ${poiError.toString()}`
  }

  return { error: error?.error || error }
}

export default useZoneContainer
